import { JsonProperty, ObjectMapper } from "json-object-mapper";
import { IModel } from "./IModel";
import { Model } from "./model";

export class EmployeeDismissalTypeModel
	extends Model
	implements IModel<EmployeeDismissalTypeModel>
{
	@JsonProperty()
	public id: string = "";

	@JsonProperty()
	public code: number = 0;

	@JsonProperty()
	public name: string = "";

	static create(input: any): EmployeeDismissalTypeModel {
		return ObjectMapper.deserialize<EmployeeDismissalTypeModel>(
			EmployeeDismissalTypeModel,
			input
		);
	}
}
